import { memo } from 'react'

import { useFlag } from '@b-stock/fe-core/bstock-next/helpers'

import { FeatureFlags } from '@/helpers/featureFlags'
import newSellerStorefrontsQuery from '@/queries/newSellerStorefrontsQuery'

import Card from './Card'
import ListingInfo from './ListingInfo'
import type { BaseListingCardProps } from './types'

const BaseListingCard2025 = memo(
  ({
    listing,
    currentPrice,
    isFdBuyNow = false,
    bidStatus,
    listingDetailsUrl,
    endTime,
    screenName,
    hasTermsRestrictions,
    position,
    impressionId: _impressionId,
    onSummarizeClick,
    summarizeLabelVariant,
  }: BaseListingCardProps) => {
    const isNewSellerTreatment =
      useFlag(FeatureFlags.NEW_SELLER_ALP_LABEL) === 'treatment'
    const { data: newSellerIds } = newSellerStorefrontsQuery.useWithOpts([], {
      enabled: isNewSellerTreatment,
    })
    const isNewSellerListing =
      isNewSellerTreatment && (newSellerIds?.has(listing.storefrontId) ?? false)
    const showCreditCardTag =
      useFlag(FeatureFlags.ENABLE_CC_SURFACING) &&
      listing.isCreditCardEnabled === true
    // The search field is absent on records the pipeline has not populated,
    // which means "not Seller Collects" rather than "unknown".
    const showSellerCollectsTag =
      useFlag(FeatureFlags.SELLER_COLLECTS_BUYER_EXPERIENCE) &&
      listing.sellerCollects === true

    return (
      <Card
        listing={listing}
        bidStatus={bidStatus}
        listingDetailsUrl={listingDetailsUrl}
        screenName={screenName}
        position={position}
        isNewSellerListing={isNewSellerListing}
        onSummarizeClick={onSummarizeClick}
        summarizeLabelVariant={summarizeLabelVariant}
      >
        <ListingInfo
          listing={listing}
          currentPrice={currentPrice}
          isFdBuyNow={isFdBuyNow}
          endTime={endTime}
          hasTermsRestrictions={hasTermsRestrictions}
          isNewSeller={isNewSellerListing}
          showCreditCardTag={showCreditCardTag}
          showSellerCollectsTag={showSellerCollectsTag}
        />
      </Card>
    )
  }
)
BaseListingCard2025.displayName = 'BaseListingCard2025'

export { BaseListingCard2025 }
